import { messages as memo } from '@features/memo/i18n/en-US'
import { messages as packing } from '@features/packing/i18n/en-US'
import { messages as schedule } from '@features/schedule/i18n/en-US'

export default {
  anniversaries: {
    title: 'Anniversaries',
    birthday: 'Birthday',
    anniversary: 'Anniversary',
    lunar: 'Lunar',
    solar: 'Solar',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Delete this anniversary?',
    cancel: 'Cancel',
    save: 'Save',
    namePlaceholder: 'Name',
    datePlaceholder: 'Date (YYYY-MM-DD)',
    empty: 'No anniversaries yet, add one'
  },
  bodymetrics: {
    title: 'Body Metrics',
    weight: 'Weight',
    bodyFat: 'Body Fat',
    add: 'Log',
    sync: 'Sync',
    empty: 'No data yet',
    kg: 'kg',
    percent: '%',
    date: 'Date'
  },
  calendar: {
    title: 'Family Calendar',
    add: 'Add Event',
    month: 'Month',
    empty: 'No events this month',
    titleLabel: 'Title',
    dateLabel: 'Date',
    category: 'Category',
    save: 'Save',
    cancel: 'Cancel'
  },
  chat: {
    title: 'Chat',
    rooms: 'Rooms',
    send: 'Send',
    typing: 'Typing…',
    placeholder: 'Type a message…',
    empty: 'No messages',
    noRooms: 'No rooms yet',
    connected: 'Connected',
    reconnecting: 'Reconnecting…'
  },
  comments: {
    comments: 'Comments',
    addComment: 'Write a comment…',
    send: 'Send',
    delete: 'Delete',
    empty: 'No comments yet',
    vote: 'Vote',
    voted: 'Voted',
    votes: 'votes'
  },
  diary: {
    title: 'Diary',
    add: 'New Entry',
    empty: 'No entries yet, write the first one',
    mood: 'Mood',
    save: 'Save',
    cancel: 'Cancel',
    placeholder: 'What\'s on your mind…'
  },
  memo,
  misc: {
    suggestions: 'Suggestions',
    improvements: 'Improvements',
    timer: 'Pomodoro',
    add: 'Add',
    pending: 'Pending',
    adopted: 'Adopted',
    rejected: 'Rejected',
    empty: 'None',
    start: 'Start',
    pause: 'Pause',
    reset: 'Reset',
    sessions: 'Sessions Today',
    minutes: 'min'
  },
  notifications: {
    title: 'Notifications',
    markRead: 'Mark Read',
    markAllRead: 'Mark All Read',
    empty: 'No notifications',
    unread: 'Unread'
  },
  packing,
  schedule,
  strength: {
    title: 'Strength Training',
    logs: 'Logs',
    plans: 'Plans',
    config: 'Dictionary',
    currentPlan: 'Current Plan',
    muscles: 'Muscles',
    exercises: 'Exercises',
    machines: 'Equipment',
    addLog: 'Log Workout',
    editLog: 'Edit',
    deleteLog: 'Delete',
    confirmDelete: 'Delete this workout log?',
    save: 'Save',
    cancel: 'Cancel',
    empty: 'No workout logs yet',
    sets: 'sets',
    reps: 'reps',
    weight: 'kg',
    duration: 'Duration',
    feeling: 'Feeling',
    minutes: 'min',
    totalVolume: 'Total Volume'
  },
  todo: {
    title: 'To-Do',
    empty: 'No to-dos yet, add the first one',
    loading: 'Loading…',
    errorRetry: 'Failed to load, tap to retry'
  },
  travel: {
    title: 'Travel Plans',
    categories: 'Categories',
    footprint: 'Footprint',
    allPlans: 'All',
    detail: 'Detail',
    empty: 'No plans yet',
    back: 'Back to List',
    sections: 'Sections',
    info: 'Info',
    list: 'Checklist',
    timeline: 'Timeline',
    routeMap: 'Route',
    cards: 'Cards'
  }
}
